<template>
  <div :class="['VueLabel', isFile ? 'file' : '']">
    <label :for="'folder' + Key" @click="selectFile(Url)" :title="Name">{{Title}}</label>
    <i v-if="canEdit" style="padding-left: 10px;" @click.self="confirm" v-tooltip:bottom="{ html: 'מחיקה' }" class="material-icons treeBtn">delete</i>
    <!--<i v-if="canEdit" @click.self="edit" v-tooltip:bottom="{ html: 'עריכה' }" class="material-icons treeBtn" style="font-size: 16px;">border_color</i>-->
    <i  v-if="canEdit && isFolder" @click.self="showAddFile" v-tooltip:bottom="{ html: 'הוספה' }" class="material-icons treeBtn">add</i>
    <!--<i v-if="isRoot" @click="download" v-tooltip:bottom="{ html: 'הורדה' }" class="material-icons treeBtn">file_download</i>-->
  </div>
</template>
<script>
  import { db } from '../firebase';

  export default {
    name: 'FileFolderLabel',
    props: ['isRoot', 'Key', 'Name', 'Url', 'isFolder', 'isFile', 'path', 'canEdit'],
    data() {
      return {
        isChecked: true,
        selectedKey: ''
      }
    },
    created() {
      this.$Log("Vue [FileFolderLabel] is created ...");
    },
    ready() {
      this.$Log("Vue [FileFolderLabel] is ready ...");
    },
    mounted() {
      this.$Log("Vue [FileFolderLabel] is mounted ...");
    },
    updated() {
      this.$Log("Vue [FileFolderLabel] is updated ...");
    },
    computed: {
      Title() {
        var maxLength = 10;
        if (this.isRoot) {
          maxLength = 20;
        }

        if (this.Name && this.Name.length > maxLength) {
          return this.Name.substring(0, maxLength) + '...';
        }
        else {
          return this.Name;
        }
      }
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        var vm = this;
        if (val) {
          if (vm.selectedKey == vm.Key) {
            if (vm.$root.confirm.caller == 'RemoveFolder') {
              vm.removeFolder();
            }
            if (vm.$root.confirm.caller == 'RemoveFile') {
              vm.removeFile();
            }
          }
        }
      }
    },
    methods: {
      selectFile(url) {
        if (url) {
          console.log("selectFile >>> " + url);
          this.$root.selectedFile = url;
        }
      },
      showAddFile() {
        this.$root.confirmAddFile.path = this.path;
        this.$root.confirmAddFile.isVisible = true;
      },
      confirm() {
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק מסמך זה?',
          caller: 'RemovePlan',
          isConfirmed: false
        }

        this.selectedKey = this.Key;

        if (this.isFile) {
          this.$root.confirm.question = 'האם אתה בטוח ברצונך למחוק מסמך זה?';
          this.$root.confirm.caller = 'RemoveFile';
        }

        if (this.isFolder) {
          this.$root.confirm.question = 'האם אתה בטוח ברצונך למחוק תיקייה זו?';
          this.$root.confirm.caller = 'RemoveFolder';
        }
        
      },
      remove() {
        plansRef.child(this.popup.data['.key']).remove();
      },
      download() {
      },
      edit() {
        this.selectedKey = this.Key;
        this.$root.confirmAddFile.path = this.path;
        this.$root.confirmAddFile.isVisible = true;
      },
      removeFolder() {
        //alert(this.path);
        var planeFolderRef = db.ref(this.path);
        planeFolderRef.remove();
        this.$root.isUpdatedPlan = true;
        this.selectedKey = '';
      },
      removeFile() {
        //alert(this.path)
        var planeFileRef = db.ref(this.path);
        planeFileRef.remove();
        this.$root.isUpdatedPlan = true;
        this.selectedKey = '';
      },
    }
  }
</script>
<style>
  .VueLabel {
    background: url('../assets/folder-horizontal.png');
    background-repeat: no-repeat;
    /*background-size: 15px 1px;*/
    background-position: 95% 1px;
    cursor: pointer;
    display: block;
    /*padding-left: 37px;*/
    padding-right: 37px;
    text-align: right;
    line-height: 18px;
    height: 25px;
  }

    .VueLabel > label {
      cursor: pointer;
    }

    .file {
      background: url('../assets/document.png');
      background-repeat: no-repeat;
      /*background-size: 15px 1px;*/
      background-position: 95% 1px;
      padding-right: 37px;
      text-align: right;
      margin-right: 20px;
      cursor: pointer;
    }

  .treeBtn {
    font-size: 18px;
    line-height: 18px;
    padding-top: 3px;
    padding-left: 5px;
    float: left;
    opacity: 0;
  }

  .VueLabel:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .VueLabel:hover .treeBtn {
    opacity: 1.0;
  }
</style>



// WEBPACK FOOTER //
// FileFolderLabel.vue?7a555796